import { useCallback, useState } from 'react';
import { AuthErrorMessage, AuthPayloadSuccess } from '../../lib/authenticate';
import { convertGuest } from '../../lib/convertGuest';
import { useCookies } from '../useCookies';
import { useUser } from '../useUser';

type HandleConvertGuestProps = {
  email: string;
  first_name?: string;
  last_name?: string;
  password: string;
};

export const useConvertGuest = () => {
  const [error, setError] = useState<AuthErrorMessage>('');
  const [loading, setLoading] = useState(false);
  const {
    cookies: { cartId }
  } = useCookies();
  const {
    setUserData,
    user: { id, accessToken }
  } = useUser();

  const handleConvertGuest = useCallback(
    (values: HandleConvertGuestProps) => {
      const handleError = (error: Error) => {
        setError(error.message);
        setLoading(false);
        throw error;
      };

      const handleSuccess = (user: AuthPayloadSuccess) => {
        setUserData({ ...user, isLoggedIn: true });
        setLoading(false);
        return user;
      };

      setLoading(true);

      return convertGuest({ accessToken, userId: id, values: { ...values, cart_id: cartId } })
        .then(handleSuccess)
        .catch(handleError);
    },
    [setError, setUserData, id, accessToken, cartId]
  );

  return { error, loading, handleConvertGuest };
};
